import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_private/_route/_internal/tools/pathway-activity-defaults/',
)({});
